import "../styles/Home.css";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const Home = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const items = [
    {
      title: "Social Justice",
      tamiltitle: "வளர்ச்சி",
      description: "Focused on infrastructure growth, technology advancement, and economic progress for the nation.",
      tamildescription: "முதன்மை கட்டமைப்பு வளர்ச்சி, தொழில்நுட்ப முன்னேற்றம் மற்றும் நாட்டின் பொருளாதார முன்னேற்றத்தில் கவனம் செலுத்துகிறோம்.",
      image: "/assets/Frame (2).png"
    },
    {
      title: "Governance",
      tamiltitle: "நல்லாட்சி",
      description: "Transparent, accountable, and citizen-centric governance for efficient public services.",
      tamildescription: "வெளிப்படை, பொறுப்பு மற்றும் குடிமக்கள் மைய ஆட்சி திறமையான பொது சேவைகளை வழங்குகிறது.",
      image: "/assets/Frame (1).png"
    },
    {
      title: "Development",
      tamiltitle: "தேசிய பாதுகாப்பு",
      description: "Strengthening defense, internal security, and safeguarding national interests.",
      tamildescription: "பாதுகாப்பு, உள் பாதுகாப்பு மற்றும் தேசிய நலன்களை பலப்படுத்துதல்.",
      image: "/assets/Frame (3).png"
    },
    {
      title: "Equality & Rights",
      tamiltitle: "அனைவரையும் உள்ளடக்கிய வளர்ச்சி",
      description: "Ensuring equal opportunities, social justice, and sustainable growth for all communities.",
      tamildescription: "அனைத்து சமூகங்களுக்கும் சம வாய்ப்புகள், சமூக நீதி மற்றும் நிலையான வளர்ச்சி உறுதி செய்கிறோம்.",
      image: "/assets/Frame (4).png"
    }
  ];

  const leaders = [
    {
      title: "Kalaignar M. Karunanidhi",
      tamiltitle: "Kalaignar M. Karunanidhi",
      description: "The Architect of Modern Tamil Nadu",
      tamildescription: "புரட்சித் தலைவர்",
      image: "/assets/kailig.jpg"
    },
    {
      title: "Thalapathy MK Stalin",
      tamiltitle: "Thalapathy MK Stalin",
      description: "Honourable Chief Minister",
      tamildescription: "புரட்சித் தலைவி அம்மா",
      image: "/assets/stalin.jpg"
    },
    {
      title: "Udhayanidhi",
      tamiltitle: "Udhayanidhi",
      description: "General Secretary",
      tamildescription: "மாண்புமிகு பொதுச்செயலாளர்",
      image: "/assets/uday.jpg"
    }
  ];

  const content = {
    maintitle: {
      english: "Rising Sun of TamilNadu",
      tamil: "DMK"
    },
    herouptitle: {
      english: "Honourable Chief Minister",
      tamil: "மாண்புமிகு பொதுச்செயலாளர்"
    },
    heroTitle: {
      english: "M.K. Stalin",
      tamil: "மு.க. ஸ்டாலின்"
    },
    heroSubtitle: {
      english: "Dravida Munnetra Kazhagam (DMK)",
      tamil: "திராவிட முன்னேற்றக் கழகம்"
    },
    heroTagline: {
      english: "Leading Tamil Nadu towards a future of social justice, equality, and inclusive growth. A government for the people, by the people.",
      tamil: "Leading Tamil Nadu towards a future of social justice, equality, and inclusive growth. A government for the people, by the people."
    },
    coreFocus: {
      english: "Pillars of Governance",
      tamil: "எங்கள் முக்கிய கவனம்"
    },
    WelfareFocus: {
      english: "Public Welfare Focus",
      tamil: "எங்கள் முக்கிய கவனம்"
    },
    leadership: {
      english: "Leadership Legacy",
      tamil: "தலைமைத்துவ மரபு"
    },
    transformingIndia: {
      english: "Transforming India",
      tamil: "இந்தியாவை மாற்றியமைத்தல்"
    },
    transformingDescription: {
      english: "Through visionary policies and relentless execution, building the foundation for a developed nation.",
      tamil: "தொலைநோக்கு கொள்கைகள் மற்றும் தளராத செயல்பாட்டின் மூலம், ஒரு வளர்ந்த நாட்டின் அடித்தளத்தை கட்டி எழுப்புகிறோம்."
    },
    viewAchievements: {
      english: "View All Achievements",
      tamil: "அனைத்து சாதனைகளையும் காண்க"
    },
    galleryTitle: {
      english: "Moments & Activities",
      tamil: "நிகழ்வுகள் & செயல்பாடுகள்"
    },
    joinMovement: {
      english: "Join the Movement for Change",
      tamil: "இயக்கத்தில் சேருங்கள்"
    },
    joinDescription: {
      english: "Be a part of the Dravidian model of governance. Connect with us today.",
      tamil: "தேசம் கட்டும் பணியில் பங்கேற்கவும். இன்றே எங்களுடன் தொடர்பு கொள்ளுங்கள்."
    },
    infrastructure: {
      english: "Roads & Transport",
      tamil: "உள்கட்டமைப்பு"
    },
    infrastructure1: {
      english: "World-class connectivity",
      tamil: "World-class connectivity"
    },
    digitalIndia: {
      english: "Water Management",
      tamil: "டிஜிட்டல் இந்தியா"
    },
    digitalIndia1: {
      english: "Sustainable Solutions",
      tamil: "Sustainable Solutions"
    },
    education: {
      english: "Education",
      tamil: "கல்வி"
    },
    education1: {
      english: "Knowledge Revolution",
      tamil: "Knowledge Revolution"
    },
    healthcare: {
      english: "Healthcare",
      tamil: "சுகாதாரம்"
    },
    healthcare1: {
      english: "Healthcare for All",
      tamil: "சுகாதாரம்"
    }
  };

  return (
    <>
      <section className="hero">
        <div className="hero-container">
          <div className="hero-left">
            <h1 className="maintitle"><span><img className="maintitleimag" src="/assets/Frame.png" alt="" /></span>{content.maintitle[language]}</h1>
            <h1 className="herouptitle">{content.herouptitle[language]}</h1>
            <h1 className="nammeee">{content.heroTitle[language]}</h1>
            <p>
              {content.heroSubtitle[language]}
            </p>
            <p className="lighttext">{content.heroTagline[language]}</p>
            <div className="hero-buttons">
              <button
                className="outline1"
                onClick={() => navigate("/Mission-vission")}
              >
                {language === 'tamil' ? 'குறிக்கோள் & பார்வை' : 'Mission & Vision'}
              </button>

              <button
                className="outline"
                onClick={() => navigate("/About")}
              >
                {language === 'tamil' ? 'எங்களை பற்றி' : 'About Us'}
              </button>

              <button
                className="outline"
                onClick={() => navigate("/Contact")}
              >
                {language === 'tamil' ? 'தொடர்பு கொள்ளுங்கள்' : 'Contact Us'}
              </button>
            </div>
          </div>

          <div className="hero-right">
            <div className="image-card">
              <div className="image-placeholder"><img src="/assets/stalin.jpg" alt="" /></div>
            </div>
          </div>
        </div>
      </section>
      <section className="core-focus">
        <h2 className="coretitle">{content.coreFocus[language]}</h2>
        <p>Our commitment to the people of Tamil Nadu is built on four unshakeable pillars of Dravidian ideology.</p>
        <div className="focus-grid">
          {items.map((item, i) => (
            <div key={i} className="focus-card">
              <img src={item.image} alt="" />
              <h4>{language === 'tamil' ? item.tamiltitle : item.title}</h4>
              <p>{language === 'tamil' ? item.tamildescription : item.description}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="leadership">
        <div className="leadershiptit">
          <h2 className="coretitle">{content.leadership[language]}</h2>
          <p className="leaderimgg">View Part History <img src="/assets/next.png" alt="" /> </p>
        </div>
        <div className="leader-grid">
          {leaders.map((leader, i) => (
            <div key={i} className={`leader-card`}>
              <img src={leader.image} alt="" className="leader-img" />
              {/* <p className="tamildess">{language === 'tamil' ? leader.tamildescription : leader.tamildescription}</p> */}
              <h4 className="leadtitle">{language === 'tamil' ? leader.tamiltitle : leader.title}</h4>
              <p className="leaddesc">{language === 'tamil' ? leader.tamildescription : leader.description}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="welfare-focus">
        <h2 className="coretitle">{content.WelfareFocus[language]}</h2>
        <p>Our administration is dedicated to uplifting every sector of society through targeted welfare schemes.</p>
        <div className="focus-grid">
          {items.map((item, i) => (
            <div key={i} className="welfocus-card">
              <img src={item.image} alt="" />
              <h4>{language === 'tamil' ? item.tamiltitle : item.title}</h4>
              <p>{language === 'tamil' ? item.tamildescription : item.description}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="join">
        <div className="joinit">
          <h2>{content.joinMovement[language]}</h2>
          <p>{content.joinDescription[language]}</p>
          <div className="joining1">
            <div className="joining11">
              <div className="joining21">
                <h1>Visit Us</h1>
                <p>Anna Arivalayam, Chennai</p>
              </div>
            </div>
            <div className="joining11">
              <div className="joining21">
                <h1>Call Us</h1>
                <p>+91 44 2434 8888</p>
              </div>
            </div>
            <div className="joining11">
              <div className="joining21">
                <h1>Email Us</h1>
                <p>contact@dmk.in</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-boxes">
          <div className="contact-boxespar par1">
            Contact party office
          </div>
          <div className="contact-boxespar par2">
            Whatsapp Us
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;